module.exports = __webpack_public_path__ + "img/654.de9937e6.png";